import React from "react";
import { ControlLabel, Button, Alert } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import NewsList from "./news-list.jsx";

export default class ManageNews extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            title: '',
            yesLabel: '',
            noLabel: '',
            backLabel: '',
            addNewItemLabel: '',
            newsList: []
        }

        this.loadViewModel = this.loadViewModel.bind(this);
        this.onAddNewItem = this.onAddNewItem.bind(this);
        this.onBack = this.onBack.bind(this);
        this.setNewsList = this.setNewsList.bind(this);
    }

    componentDidMount() {
        this.loadViewModel();
    }

    loadViewModel() {
        let self = this;

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        ajax.vm().get("manage-news")
            .then(function (res) {
                self.setState({
                    title: res.data.title,
                    yesLabel: res.data.yesLabel, 
                    noLabel: res.data.noLabel,
                    backLabel: res.data.backLabel,
                    addNewItemLabel: res.data.addNewItemLabel,
                    newsList: res.data.newsList
                });
                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onAddNewItem() {
        let self = this;
        window.location = context.root() + '/app/add-news/0';
    }

    onBack() {
        let self = this;
        window.location = context.root() + '/app/marketing-admin';
    }

    setNewsList(data) {
        this.setState({
            newsList: data
        });
    }

    render() {
        return (
            <div className="container">
                <div className="container-fluid">
                    <div className="row">
                        <h2 className="text-center ap-title">{this.state.title}</h2>
                    </div>
                    <br /><br />
                    <div className="row">
                        <div className="col-md-6 col-lg-6">
                            <Button onClick={this.onAddNewItem} className="btn-info ap-fullsize" >{this.state.addNewItemLabel}</Button>
                        </div>
                        <div className="col-md-6 col-lg-6">
                            <Button onClick={this.onBack} className="btn-info ap-fullsize">{this.state.backLabel}</Button>
                        </div>
                    </div>
                    <br />
                    <NewsList onChange={this.setNewsList} newsList={this.state.newsList} noLabel={this.state.noLabel} yesLabel={this.state.yesLabel}></NewsList>
                </div>
            </div>
        );
    }
}